export default "__VITE_ASSET__c_Nk7tZ3__"